import React, { useState, useEffect } from "react";

import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/Course app-pana (1) 1.png";
import CourseList from "./CourseList";
import Navbar2 from "../Components/Navbar2";
import Footer2 from "../Components/Footer2";
import { getallCategory, getallCourse } from "../Common/apis";
import Loader from "../Loader/Loader.jsx";
import Aos from "aos";

function Home2() {
  useEffect(() => {
          Aos.init({
            duration: 1000, // animation duration in ms
            once: true,     // animate only once
          });
        }, []);
  const [activeTab, setActiveTab] = useState(1);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [courses, setCourses] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const catRes = await getallCategory();
        const courseRes = await getallCourse();
        setCategories(catRes.data);
        setCourses(courseRes.data);
        setSelectedCategory(catRes.data[0]?._id);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);
      }
    };

    fetchData();
  }, []);

  console.log(categories);
  console.log(courses);

  const handleCategoryClick = (catId) => {
    setSelectedCategory(catId);
  };

  const filteredCourses = courses.filter(
    (course) => course.category?._id === selectedCategory
  );

  // console.log(filteredCourses);
  // console.log(selectedCategory);

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  return (
    <>
      <Navbar2 />
      {loading && <Loader />}
      <div className="new-home">
        <div className="new-home-center">
          <h2
          data-aos="flip-up"
            style={{ textShadow: "1px 1px #FDD60D" }}
            className="font-[400] text-center font-sans md:text-[80px] text-[40px] md:leading-[132px] leading-[82px] tracking-[-0.32px] text-[#FFFFFF]"
          >
            Our GISUL
            <br />
            <span className="font-dmserif italic md:text-[170px] text-[80px] text-[#F1E60D]">
              Course
            </span>
          </h2>
        </div>
        {/* <div className="cards-tab">
          <button
            className={activeTab === 1 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(1)}
          >
            About
          </button>
          <button
            className={activeTab === 2 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(2)}
          >
            Features
          </button>

          <button
            className={activeTab === 3 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(3)}
          >
            Services
          </button>
          <button
            className={activeTab === 4 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(4)}
          >
            Achievements
          </button>
          <button
            className={activeTab === 5 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(5)}
          >
            Review
          </button>
        </div> */}
        <div className="cards-tab">
          {categories.map((cat) => (
            <button
              key={cat._id}
              className={`tab-btn ${
                selectedCategory === cat._id ? "active" : ""
              }`}
              onClick={() => handleCategoryClick(cat._id)}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="tab-container">
          <div className="tab-content">
            <CourseList courses={filteredCourses} />
            {/* {activeTab === 1 && (
                <>
                  <div className="home-cards">
                    <div className="home-card">
                      <img src={img} />
                      <h3>AWS Skill Builder</h3>
                      <br />
                      <div className="home-card-btn">
                        <button className="bt1">7hr 24m</button>
                        <button className="bt2">$ 99.00 USD</button>
                      </div>
                    </div>
                  </div>
                </>
              )} */}
            {/* {activeTab === 1 && <CourseList />}
            {activeTab === 2 && <>3</>} */}
          </div>
        </div>

        <Footer2 />
      </div>
    </>
  );
}

export default Home2;
